import React, { useState, useEffect } from "react";
import * as MUIStyled from "../../../MUIStyled";
import * as Styled from "../../../CompanyForm.styled.js";
import { DefaultLayout } from "../../common/Layout/DefaultLayout.js";
import {
  ContactSubHeading,
} from "../../elements/Typography/TypographyVariant.js";
import { CopyLinkTextfield } from "../../elements/TextField/TextField.js";
import { CopyButton } from "../../elements/Buttons/Buttons.styled.js";
export const ContinueLaterPage = () => {
  const [link, setLink] = useState("");
  const [currentStep, setCurrentStep] = useState(1); // Default step value

  useEffect(() => {
    // Retrieve the full URL from sessionStorage
    const storedLink = sessionStorage.getItem("fullUrl");
    const storedStep = sessionStorage.getItem("currentStep");

    if (storedStep) {
      setCurrentStep(parseInt(storedStep));
    }
    if (storedLink) {
      setLink(storedLink);
    } else {
      // If no link is found in sessionStorage, you can set a default link
      setLink("");
    }
  }, []);
  const handleCopy = () => {
    navigator.clipboard
      .writeText(link)
      .then(() => {})
      .catch((error) => {});
  };

  return (
    <DefaultLayout hideContinueButton={true} currentStep={currentStep}>
      <MUIStyled.ContinueLateWrapper>
        <Styled.MainTitle style={{ margin: "40px 0 20px 0" }}>
          Thank you for completing the form so far!
        </Styled.MainTitle>
        <ContactSubHeading>
          Below is your link to continue and complete it later. Please note that
          you have 5 days to finish using this link.
        </ContactSubHeading>
        <MUIStyled.ContinueLaterBox>
          <MUIStyled.ContinueLaterTextFieldWrapper>
            <CopyLinkTextfield
              label="Company setup form link"
              inputStyle="copy"
              value={link}
            />
            <CopyButton onClick={handleCopy}>copy</CopyButton>
          </MUIStyled.ContinueLaterTextFieldWrapper>
        </MUIStyled.ContinueLaterBox>
      </MUIStyled.ContinueLateWrapper>
    </DefaultLayout>
  );
};
